import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/sso')({
  head: () => ({
    meta: [{ title: 'SSO | Tekst' }],
  }),
});
